module.exports = __webpack_public_path__ + "static/media/ds06.73419ea5.jpg";